/* eslint-disable */

<template>
  <div style="width: 100%; background-color: var(--grey_alpha)">
    <div class="view-content">
      <concordance-request
        v-if="isMounted"
        :concordance-word="concordanceWord"
        :execute-on-mount="executeOnMount"
        :publication-year="publicationYear"
      ></concordance-request>
    </div>
  </div>
</template>

<script>
import ConcordanceRequest from "@/components/ConcordanceRequest";
export default {
  name: "Concordance",
  props: {
    concordanceWord: {
      type: String,
    },
    publicationYear: {
      type: String,
    },
  },
  components: { ConcordanceRequest },
  data() {
    return {
      executeOnMount: false,
      isMounted: false,
    };
  },
  mounted() {
    if (typeof this.concordanceWord !== "undefined") {
      this.executeOnMount = true;
    } else {
      this.executeOnMount = false;
      this.isMounted = true;
    }
    this.isMounted = true;
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/Concordance.vue